import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export const useDebouncedSconto = ({ sconto, setScontoValue, debounceMs = 300 }) => {
  const [selectedDiscounts, setSelectedDiscounts] = useState({});
  const discountUpdateTimersRef = useRef({});

  const getEffectiveDiscountRaw = useCallback(
    (id) => {
      const key = String(id);
      if (Object.prototype.hasOwnProperty.call(selectedDiscounts, key)) return selectedDiscounts[key];
      return sconto?.[id];
    },
    [selectedDiscounts, sconto]
  );

  const effectiveSconto = useMemo(() => ({ ...(sconto || {}), ...selectedDiscounts }), [sconto, selectedDiscounts]);

  const flushPendingDiscountUpdates = useCallback(() => {
    Object.keys(discountUpdateTimersRef.current).forEach((key) => {
      clearTimeout(discountUpdateTimersRef.current[key]);
      delete discountUpdateTimersRef.current[key];
    });

    Object.entries(selectedDiscounts).forEach(([id, value]) => {
      setScontoValue(id, value);
    });
  }, [selectedDiscounts, setScontoValue]);

  const setDiscountDebounced = useCallback(
    (id, value) => {
      const key = String(id);
      setSelectedDiscounts((prev) => ({ ...prev, [key]: value }));

      if (discountUpdateTimersRef.current[key]) {
        clearTimeout(discountUpdateTimersRef.current[key]);
      }

      discountUpdateTimersRef.current[key] = setTimeout(() => {
        setScontoValue(id, value);
      }, debounceMs);
    },
    [debounceMs, setScontoValue]
  );

  useEffect(() => {
    return () => {
      Object.keys(discountUpdateTimersRef.current).forEach((key) => {
        clearTimeout(discountUpdateTimersRef.current[key]);
      });
      discountUpdateTimersRef.current = {};
    };
  }, []);

  return {
    selectedDiscounts,
    effectiveSconto,
    getEffectiveDiscountRaw,
    setDiscountDebounced,
    flushPendingDiscountUpdates,
    setSelectedDiscounts,
  };
};

